import { SettingsComponent } from './components/settings/settings.component';
import { ShortDateTimePipe } from './pipes/short-date-time.pipe';
import { DatasetViewerComponent } from './components/dataset-viewer/dataset-viewer.component';
import { RateWidgetComponent } from './widgets/rate-widget/rate-widget.component';
import { RatingItemComponent } from './components/rating-viewer/rating-item/rating-item.component';
import { RatingViewerComponent } from './components/rating-viewer/rating-viewer.component';
import { ReportService } from './services/report.service';
import { AboutComponent } from './components/about/about.component';
import { ReportFilterNewComponent } from './components/report-container/report-filter/report-filter-new/report-filter-new.component';
import { CustomerService } from './services/customer.service';
import { NotificationComponent } from './components/notification/notification.component';
import { NotificationService } from './services/notification.service';
import { ReportFilterComponent } from './components/report-container/report-filter/report-filter.component';
import { RaterComponent } from './components/rater/rater.component';
import { ModalComponent } from './components/modal/modal.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApiService } from './services/api.service';
import { ReportContainerComponent } from './components/report-container/report-container.component';
import { ReportRatingComponent } from './components/report-item/report-rating/report-rating.component';
import { ReportListComponent } from './components/report-list/report-list.component';
import { ReportItemComponent } from './components/report-item/report-item.component';
import { BannerComponent } from './components/banner/banner.component';
import { MenuComponent } from './components/menu/menu.component';
import { LoginComponent } from './components/login/login.component';
import { StateService } from 'src/app/services/state.service';
import { SettingsService } from './services/settings.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './app-material.module';
import { AuthGuard } from './services/auth-guard';
import { ModalService } from './services/modal.service';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SelectDropDownModule } from './modules/ngx-select-dropdown/ngx-select-dropdown.module';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';

import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { msalConfig, loginRequest, protectedResources } from './auth-config';
import { RateDistributionWidgetComponent } from './widgets/rate-distribution-widget/rate-distribution-widget.component';

@NgModule({ 
    declarations: [
        AppComponent,
        LoginComponent,
        MenuComponent,
        BannerComponent,
        ReportItemComponent,
        ReportListComponent,
        ReportRatingComponent,
        ReportContainerComponent,
        ModalComponent,
        RaterComponent,
        ReportFilterComponent,
        ReportFilterNewComponent,
        NotificationComponent,
        AboutComponent,
        RatingViewerComponent,
        RatingItemComponent,
        RateWidgetComponent,
        RateDistributionWidgetComponent,
        DatasetViewerComponent,
        ShortDateTimePipe,
        SettingsComponent
    ],
    exports: [
        ShortDateTimePipe
    ],
    bootstrap: [AppComponent, MsalRedirectComponent], 
    imports: [
        // Angular Modules
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        AngularMaterialModule,
        BsDropdownModule.forRoot(),
        MsalModule.forRoot(
            new PublicClientApplication({
                auth: {
                    clientId: msalConfig.auth.clientId,
                    authority: msalConfig.auth.authority,
                    redirectUri: msalConfig.auth.redirectUri,
                },
                cache: {
                    cacheLocation: BrowserCacheLocation.SessionStorage,
                    storeAuthStateInCookie: false, // Set to true for IE 11
                },
                system: msalConfig.system
            }),
            {
                interactionType: InteractionType.Redirect,
                authRequest: loginRequest
            },
            {
                interactionType: InteractionType.Redirect,
                protectedResourceMap: new Map([
                    [protectedResources.assetAnalyticsApi.endpoint, protectedResources.assetAnalyticsApi.scopes],
                    // Protect all relative URLs (anything that doesn't start with http:// or https://)
                    ['/', protectedResources.assetAnalyticsApi.scopes]
                ])
            }
        ),
        SelectDropDownModule,
        ProgressbarModule.forRoot()
    ], 
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        NotificationService,
        AuthGuard,
        StateService,
        ApiService,
        ModalService,
        CustomerService,
        ReportService,
        SettingsService,
        ShortDateTimePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] 
})
export class AppModule { }
